"use strict";
// tslint:disable
/**
 * Sleekflow General Api
 * Sleekflow General Api
 *
 * The version of the OpenAPI document: api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowHubApi = void 0;
var runtime_1 = require("../runtime");
/**
 * no description
 */
var FlowHubApi = /** @class */ (function (_super) {
    __extends(FlowHubApi, _super);
    function FlowHubApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlowHubApi.prototype.flowHubBlobsCreateBlobDownloadSasUrlsPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerCreateBlobDownloadSasUrlsRequest = _a.travisBackendFlowHubsControllersFlowHubControllerCreateBlobDownloadSasUrlsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Blobs/CreateBlobDownloadSasUrls',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerCreateBlobDownloadSasUrlsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubBlobsCreateBlobUploadSasUrlsPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerCreateBlobUploadSasUrlsRequest = _a.travisBackendFlowHubsControllersFlowHubControllerCreateBlobUploadSasUrlsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Blobs/CreateBlobUploadSasUrls',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerCreateBlobUploadSasUrlsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubExecutionsCancelWorkflowExecutionPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerCancelWorkflowExecutionRequest = _a.travisBackendFlowHubsControllersFlowHubControllerCancelWorkflowExecutionRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Executions/CancelWorkflowExecution',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerCancelWorkflowExecutionRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubExecutionsGetStateStepExecutionsPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerGetStateStepExecutionsRequest = _a.travisBackendFlowHubsControllersFlowHubControllerGetStateStepExecutionsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Executions/GetStateStepExecutions',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerGetStateStepExecutionsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubExecutionsGetWorkflowExecutionPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerGetWorkflowExecutionRequest = _a.travisBackendFlowHubsControllersFlowHubControllerGetWorkflowExecutionRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Executions/GetWorkflowExecution',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerGetWorkflowExecutionRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubExecutionsGetWorkflowExecutionStatisticsPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerGetWorkflowExecutionStatisticsRequest = _a.travisBackendFlowHubsControllersFlowHubControllerGetWorkflowExecutionStatisticsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Executions/GetWorkflowExecutionStatistics',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerGetWorkflowExecutionStatisticsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubExecutionsGetWorkflowExecutionsByStatePost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerGetWorkflowExecutionsByStateRequest = _a.travisBackendFlowHubsControllersFlowHubControllerGetWorkflowExecutionsByStateRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Executions/GetWorkflowExecutionsByState',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerGetWorkflowExecutionsByStateRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubExecutionsGetWorkflowExecutionsPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerGetWorkflowExecutionsRequest = _a.travisBackendFlowHubsControllersFlowHubControllerGetWorkflowExecutionsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Executions/GetWorkflowExecutions',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerGetWorkflowExecutionsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubExecutionsGetWorkflowStepExecutionsPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerGetWorkflowStepExecutionsRequest = _a.travisBackendFlowHubsControllersFlowHubControllerGetWorkflowStepExecutionsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Executions/GetWorkflowStepExecutions',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerGetWorkflowStepExecutionsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubFlowHubConfigsEnrollFlowHubPost = function (_a, opts) {
        var body = _a.body;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/FlowHubConfigs/EnrollFlowHub',
            method: 'POST',
            headers: headers,
            body: body,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubFlowHubConfigsGetFlowHubConfigPost = function (_a, opts) {
        var body = _a.body;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/FlowHubConfigs/GetFlowHubConfig',
            method: 'POST',
            headers: headers,
            body: body,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubFlowHubConfigsUnenrollFlowHubPost = function (_a, opts) {
        var body = _a.body;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/FlowHubConfigs/UnenrollFlowHub',
            method: 'POST',
            headers: headers,
            body: body,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubFlowHubConfigsUpdateFlowHubConfigPost = function (_a, opts) {
        var body = _a.body;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/FlowHubConfigs/UpdateFlowHubConfig',
            method: 'POST',
            headers: headers,
            body: body,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubStatesGetObjectStatesPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerGetObjectStatesRequest = _a.travisBackendFlowHubsControllersFlowHubControllerGetObjectStatesRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/States/GetObjectStates',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerGetObjectStatesRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubStatesGetStatesPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerGetStatesRequest = _a.travisBackendFlowHubsControllersFlowHubControllerGetStatesRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/States/GetStates',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerGetStatesRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowGroupsCreateWorkflowGroupPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerCreateWorkflowGroupRequest = _a.travisBackendFlowHubsControllersFlowHubControllerCreateWorkflowGroupRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/WorkflowGroups/CreateWorkflowGroup',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerCreateWorkflowGroupRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowGroupsDeleteWorkflowGroupPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerDeleteWorkflowGroupRequest = _a.travisBackendFlowHubsControllersFlowHubControllerDeleteWorkflowGroupRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/WorkflowGroups/DeleteWorkflowGroup',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerDeleteWorkflowGroupRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowGroupsGetWorkflowGroupsPost = function (_a, opts) {
        var body = _a.body;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/WorkflowGroups/GetWorkflowGroups',
            method: 'POST',
            headers: headers,
            body: body,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowGroupsUpdateWorkflowGroupPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerUpdateWorkflowGroupRequest = _a.travisBackendFlowHubsControllersFlowHubControllerUpdateWorkflowGroupRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/WorkflowGroups/UpdateWorkflowGroup',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerUpdateWorkflowGroupRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsAssignWorkflowToGroupPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerAssignWorkflowToGroupRequest = _a.travisBackendFlowHubsControllersFlowHubControllerAssignWorkflowToGroupRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/AssignWorkflowToGroup',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerAssignWorkflowToGroupRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsCancelManualEnrollPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerCancelManualEnrollWorkflowRequest = _a.travisBackendFlowHubsControllersFlowHubControllerCancelManualEnrollWorkflowRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/CancelManualEnroll',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerCancelManualEnrollWorkflowRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsCountWorkflowsPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerCountWorkflowsRequest = _a.travisBackendFlowHubsControllersFlowHubControllerCountWorkflowsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/CountWorkflows',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerCountWorkflowsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsCreateWorkflowPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerCreateWorkflowRequest = _a.travisBackendFlowHubsControllersFlowHubControllerCreateWorkflowRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/CreateWorkflow',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerCreateWorkflowRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsCreateWorkflowWebhookTriggerPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerCreateWorkflowWebhookTriggerRequest = _a.travisBackendFlowHubsControllersFlowHubControllerCreateWorkflowWebhookTriggerRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/CreateWorkflowWebhookTrigger',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerCreateWorkflowWebhookTriggerRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsDeleteVersionedWorkflowPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerDeleteVersionedWorkflowRequest = _a.travisBackendFlowHubsControllersFlowHubControllerDeleteVersionedWorkflowRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/DeleteVersionedWorkflow',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerDeleteVersionedWorkflowRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsDeleteWorkflowPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerDeleteWorkflowRequest = _a.travisBackendFlowHubsControllersFlowHubControllerDeleteWorkflowRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/DeleteWorkflow',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerDeleteWorkflowRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsDisableWorkflowPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerDisableWorkflowRequest = _a.travisBackendFlowHubsControllersFlowHubControllerDisableWorkflowRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/DisableWorkflow',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerDisableWorkflowRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsDuplicateWorkflowPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerDuplicateWorkflowRequest = _a.travisBackendFlowHubsControllersFlowHubControllerDuplicateWorkflowRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/DuplicateWorkflow',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerDuplicateWorkflowRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsEnableWorkflowPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerEnableWorkflowRequest = _a.travisBackendFlowHubsControllersFlowHubControllerEnableWorkflowRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/EnableWorkflow',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerEnableWorkflowRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsGetActiveWorkflowPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerGetActiveWorkflowRequest = _a.travisBackendFlowHubsControllersFlowHubControllerGetActiveWorkflowRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/GetActiveWorkflow',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerGetActiveWorkflowRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsGetLatestWorkflowPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerGetLatestWorkflowRequest = _a.travisBackendFlowHubsControllersFlowHubControllerGetLatestWorkflowRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/GetLatestWorkflow',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerGetLatestWorkflowRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsGetManualEnrollmentStatusPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerGetManualEnrollmentStatusRequest = _a.travisBackendFlowHubsControllersFlowHubControllerGetManualEnrollmentStatusRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/GetManualEnrollmentStatus',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerGetManualEnrollmentStatusRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsGetVersionedWorkflowPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerGetVersionedWorkflowRequest = _a.travisBackendFlowHubsControllersFlowHubControllerGetVersionedWorkflowRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/GetVersionedWorkflow',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerGetVersionedWorkflowRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsGetWorkflowPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerGetWorkflowRequest = _a.travisBackendFlowHubsControllersFlowHubControllerGetWorkflowRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/GetWorkflow',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerGetWorkflowRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsGetWorkflowWebhookTriggerUrlGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/FlowHub/Workflows/GetWorkflowWebhookTriggerUrl',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsGetWorkflowWebhookTriggersPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerGetWorkflowWebhookTriggersRequest = _a.travisBackendFlowHubsControllersFlowHubControllerGetWorkflowWebhookTriggersRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/GetWorkflowWebhookTriggers',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerGetWorkflowWebhookTriggersRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsGetWorkflowsPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerGetWorkflowsRequest = _a.travisBackendFlowHubsControllersFlowHubControllerGetWorkflowsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/GetWorkflows',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerGetWorkflowsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsManualEnrollPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerManualEnrollWorkflowRequest = _a.travisBackendFlowHubsControllersFlowHubControllerManualEnrollWorkflowRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/ManualEnroll',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerManualEnrollWorkflowRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsScheduleDeleteWorkflowsPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerScheduleDeleteWorkflowsRequest = _a.travisBackendFlowHubsControllersFlowHubControllerScheduleDeleteWorkflowsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/ScheduleDeleteWorkflows',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerScheduleDeleteWorkflowsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsSwapWorkflowsPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerSwapWorkflowsRequest = _a.travisBackendFlowHubsControllersFlowHubControllerSwapWorkflowsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/SwapWorkflows',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerSwapWorkflowsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsUpdateWorkflowPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerUpdateWorkflowRequest = _a.travisBackendFlowHubsControllersFlowHubControllerUpdateWorkflowRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/UpdateWorkflow',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerUpdateWorkflowRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    FlowHubApi.prototype.flowHubWorkflowsUpdateWorkflowWebhookTriggerPost = function (_a, opts) {
        var travisBackendFlowHubsControllersFlowHubControllerUpdateWorkflowWebhookTriggerRequest = _a.travisBackendFlowHubsControllersFlowHubControllerUpdateWorkflowWebhookTriggerRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/FlowHub/Workflows/UpdateWorkflowWebhookTrigger',
            method: 'POST',
            headers: headers,
            body: travisBackendFlowHubsControllersFlowHubControllerUpdateWorkflowWebhookTriggerRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    return FlowHubApi;
}(runtime_1.BaseAPI));
exports.FlowHubApi = FlowHubApi;
